module.exports = require('./helpers/bundle-url').getBundleURL('bVcOE') + "logo.c51670a8.svg";